module.exports = __webpack_public_path__ + "fonts/Inter-400-vietnamese47.5fc7f74.woff2";